import { Login } from "components";
import React from "react";

export const LoginPage = () => {
    return (
    <Login/>
    );
};